/*jshint -W069 */
/**
 * 
 * @class Api
 * @param {(string|object)} [domainOrOptions] - The project domain or options object. If object, see the object's optional properties.
 * @param {string} [domainOrOptions.domain] - The project domain
 * @param {object} [domainOrOptions.token] - auth token - object with value property and optional headerOrQueryName and isQuery properties
 */
var Api = (function() {
    'use strict';

    var Q = require('q');
    var settingsInstance = require('./SettingsInstance.js');
    var customRequest = require('./requestHelper.js').customRequest;
    var mergeQueryParams = require('./requestHelper.js').mergeQueryParams;

    function Api(options) {
        var domain = (typeof options === 'object') ? options.domain : options;
        this.domain = domain ? domain : settingsInstance.baseApiUrl;
        if (this.domain.length === 0) {
            throw new Error('Domain parameter must be specified as a string.');
        }
    }

    /**
     * HTTP Request
     * @method
     * @name Api#request
     * @param {string} method - http method
     * @param {string} path - path
     * @param {string} url
     * @param {object} body - body parameters / object
     * @param {object} headers - header parameters
     * @param {object} queryParameters - querystring parameters
     * @param {object} form - form data object
     * @param {object} deferred - promise object
     */
    Api.prototype.request = customRequest;

    /**
     * Analiza kosztu wykorzystania słupów energetycznych
     * @method
     * @name Api#postAnalizySlupowEnergetycznychKosztWykorzystania
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {boolean} parameters.raport - Czy utwożyć raport w magazynie raportów
     * @param {} parameters.body - 
     */
    Api.prototype.postAnalizySlupowEnergetycznychKosztWykorzystania = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/analizy/slupow_energetycznych/koszt_wykorzystania',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        if (parameters['raport'] !== undefined) {
            queryParameters['raport'] = parameters['raport'];
        }

        if (parameters['body'] !== undefined) {
            body = parameters['body'];
        }

        if (parameters['body'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: body'));
            return deferred.promise;
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('POST', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Pobierz listę raportów
     * @method
     * @name Api#getRaporty
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {string} parameters.page_number - Numer strony (domyślnie None - zwracana całość)
     * @param {string} parameters.items_per_page - Ilość elementów na stronę (domyślnie None - zwracana całość)
     * @param {string} parameters.order_by - Wg której kolumny sortowanie (domyślnie id)
     * @param {boolean} parameters.desc - Czy sortowanie zstępne
     * @param {string} parameters.numer_raportu - Filtr numer raportu
     * @param {string} parameters.kategoria - Filtr kategoria
     * @param {string} parameters.status - Filtr status
     * @param {string} parameters.data_od - Filtr data wykonania od
     * @param {string} parameters.data_do - Filtr data wykonania do
     * @param {string} parameters.data_zaplanowania_od - Filtr data zaplanowania od
     * @param {string} parameters.data_zaplanowania_do - Filtr data zaplanowania do
     * @param {string} parameters.filter_user_str - Filtr użytkownik
     * @param {string} parameters.tytul - Filtr tytuł raportu
     * @param {string} parameters.control - Parametr kontrolny
     */
    Api.prototype.getRaporty = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/raporty',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        if (parameters['page_number'] !== undefined) {
            queryParameters['page_number'] = parameters['page_number'];
        }

        if (parameters['items_per_page'] !== undefined) {
            queryParameters['items_per_page'] = parameters['items_per_page'];
        }

        if (parameters['order_by'] !== undefined) {
            queryParameters['order_by'] = parameters['order_by'];
        }

        if (parameters['desc'] !== undefined) {
            queryParameters['desc'] = parameters['desc'];
        }

        if (parameters['numer_raportu'] !== undefined) {
            queryParameters['numer_raportu'] = parameters['numer_raportu'];
        }

        if (parameters['kategoria'] !== undefined) {
            queryParameters['kategoria'] = parameters['kategoria'];
        }

        if (parameters['status'] !== undefined) {
            queryParameters['status'] = parameters['status'];
        }

        if (parameters['data_od'] !== undefined) {
            queryParameters['data_od'] = parameters['data_od'];
        }

        if (parameters['data_do'] !== undefined) {
            queryParameters['data_do'] = parameters['data_do'];
        }

        if (parameters['data_zaplanowania_od'] !== undefined) {
            queryParameters['data_zaplanowania_od'] = parameters['data_zaplanowania_od'];
        }

        if (parameters['data_zaplanowania_do'] !== undefined) {
            queryParameters['data_zaplanowania_do'] = parameters['data_zaplanowania_do'];
        }

        if (parameters['filter_user_str'] !== undefined) {
            queryParameters['filter_user_str'] = parameters['filter_user_str'];
        }

        if (parameters['tytul'] !== undefined) {
            queryParameters['tytul'] = parameters['tytul'];
        }

        if (parameters['control'] !== undefined) {
            queryParameters['control'] = parameters['control'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Dodaj raport
     * @method
     * @name Api#postRaporty
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {} parameters.body - 
     */
    Api.prototype.postRaporty = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/raporty',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        if (parameters['body'] !== undefined) {
            body = parameters['body'];
        }

        if (parameters['body'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: body'));
            return deferred.promise;
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('POST', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Pobierz plik raportu po UUID
     * @method
     * @name Api#getRaportyByUuidByUid
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.uid - UUID
     * @param {boolean} parameters.download - Czy dodawać nagłówek Content-Disposition
     */
    Api.prototype.getRaportyByUuidByUid = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/raporty/by_uuid/{uid}',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/octet-stream'];

        parameterPath = parameterPath.replace('{uid}', parameters['uid']);

        if (parameters['uid'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: uid'));
            return deferred.promise;
        }

        if (parameters['download'] !== undefined) {
            queryParameters['download'] = parameters['download'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Usuń raporty
     * @method
     * @name Api#deleteRaportyById
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - ID
     * @param {string} parameters.token - Token
     */
    Api.prototype.deleteRaportyById = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/raporty/{id}',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('DELETE', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Pobierz szczegóły raportu
     * @method
     * @name Api#getRaportyById
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {string} parameters.id - ID
     * @param {string} parameters.control - Parametr kontrolny
     */
    Api.prototype.getRaportyById = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/raporty/{id}',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['control'] !== undefined) {
            queryParameters['control'] = parameters['control'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Edytuj raport
     * @method
     * @name Api#putRaportyById
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - ID raport
     * @param {} parameters.body - 
     * @param {string} parameters.token - Token
     */
    Api.prototype.putRaportyById = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/raporty/{id}',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['body'] !== undefined) {
            body = parameters['body'];
        }

        if (parameters['body'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: body'));
            return deferred.promise;
        }

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('PUT', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Pobierz plik raportu
     * @method
     * @name Api#getRaportyByIdPobierz
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {string} parameters.id - ID
     * @param {boolean} parameters.download - Czy dodawać nagłówek Content-Disposition
     */
    Api.prototype.getRaportyByIdPobierz = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/raporty/{id}/pobierz',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/octet-stream'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['download'] !== undefined) {
            queryParameters['download'] = parameters['download'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Pobierz postęp generowania raportu
     * @method
     * @name Api#getRaportyByIdPostep
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.token - Token
     * @param {string} parameters.id - ID
     */
    Api.prototype.getRaportyByIdPostep = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/raporty/{id}/postep',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Przeprowadź walidacje sesji edycyjnej
     * @method
     * @name Api#getSesjeEdycyjneByIdWalidacja
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - ID sesji
     * @param {string} parameters.token - Token
     * @param {boolean} parameters.async - Czy przeprowadzić asynchronicznie
     */
    Api.prototype.getSesjeEdycyjneByIdWalidacja = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/sesje_edycyjne/{id}/walidacja',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        if (parameters['async'] !== undefined) {
            queryParameters['async'] = parameters['async'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    return Api;
})();

exports.Api = Api;